import { render, staticRenderFns } from "./DropdownMenuDivider.vue?vue&type=template&id=47fbd2d0&"
import script from "./DropdownMenuDivider.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports